import { Outlet } from 'react-router-dom';
import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useIsMobile } from '@/lib/useMediaQuery';

/**
 * Thin wrapper for /dashboard/admin/* routes. The previous tab bar was
 * replaced by the sidebar's expandable Admin submenu, so this layout has
 * no chrome of its own — every child page renders its own PageHeader
 * inside a PageContainer just like the top-level dashboard pages.
 *
 * On phones it prepends a non-blocking notice: admin pages are dense,
 * desktop-oriented tables, so we steer (but don't force) users to a larger
 * screen while leaving the scrollable tables available as a fallback.
 */
export function AdminLayout() {
  const { t } = useTranslation('common');
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile && (
        <div className="mb-4 flex items-start gap-2 rounded-lg border border-warning/30 bg-warning/10 px-3 py-2.5 text-xs text-foreground">
          <Info className="mt-0.5 h-4 w-4 shrink-0 text-warning" />
          <span>{t('nav.adminMobileNotice')}</span>
        </div>
      )}
      <Outlet />
    </>
  );
}
